module.exports = __webpack_public_path__ + "static/media/icon_ng.3650988c.svg";